import { render, staticRenderFns } from "./advise.vue?vue&type=template&id=ac68bd6c&scoped=true&"
import script from "./advise.vue?vue&type=script&lang=js&"
export * from "./advise.vue?vue&type=script&lang=js&"
import style0 from "./advise.vue?vue&type=style&index=0&lang=css&"
import style1 from "./advise.vue?vue&type=style&index=1&id=ac68bd6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac68bd6c",
  null
  
)

export default component.exports